import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseLoadSessionRepository } from '@/modules/auth/infra'
import type { LoadSession } from '@/modules/auth/use-cases'

export function makeLoadSession(): LoadSession {
  return new SupabaseLoadSessionRepository(makeSupabaseClient()).execute
}
